var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiskesoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.111,12.15A1.537,1.537,0,0,1,12,11.68a.874.874,0,0,0-1.322,0,1.545,1.545,0,0,1-2.219,0,.875.875,0,0,0-1.323,0,1.546,1.546,0,0,1-2.22,0,.88.88,0,0,0-1.327,0,1.54,1.54,0,0,1-1.111.47.341.341,0,1,1,0-.681.886.886,0,0,0,.664-.3,1.547,1.547,0,0,1,2.221,0,.876.876,0,0,0,1.325,0,1.546,1.546,0,0,1,2.22,0,.872.872,0,0,0,1.322,0,1.543,1.543,0,0,1,2.218,0,.88.88,0,0,0,.661.3.341.341,0,0,1,0,.681Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.952,2.59a1,1,0,1,0-1.345.936V8.167a.944.944,0,1,1-1.887,0v-.19a.34.34,0,0,0,.507-.412L6.693,6.288a.341.341,0,0,0-.655.132V8.167a1.625,1.625,0,0,0,3.25,0V3.526A1,1,0,0,0,9.952,2.59ZM8.947,2.267a.324.324,0,1,1-.323.323A.324.324,0,0,1,8.947,2.267Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiskesoe);
export default __webpack_public_path__ + "static/media/FISKESOE.6cc8980161dc9fd4022a4c669b2721e9.svg";
export { ForwardRef as ReactComponent };